import { Component } from '@angular/core';

@Component({
    selector: 'njo-fireworks',
    templateUrl: './fireworks.component.html',
    standalone: false
})
export class FireworksComponent {

  constructor() { }

}
